export interface MarkerConfig {
  type: MapMarkerType;

  icon?: string;
  label?: string;

  feature: google.maps.Data.Feature;
  map: google.maps.Map | google.maps.Data;

  inactive?: boolean;
}

export const enum MapMarkerType {
  Icon,
  Badge,
  Text,
}
